import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id FC508376-0233-498A-ABF8-B289241031FF
 * name abjad-hebrew
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/abjad-hebrew.svg
 * tags
 * - Alpha / Numeric 
 */
export const AbjadHebrewIcon = createSvgIcon(<><path d="M3.9 4L9 10.03C7.58 10.17 6.36 11.18 6 12.59L4 20H6.07L7.92 13.11C8.09 12.46 8.69 12 9.36 12H10.69L17.47 20H20.1L15 13.97C16.42 13.83 17.64 12.82 18 11.41L20 4H17.93L16.08 10.89C15.91 11.54 15.31 12 14.64 12H13.31L6.53 4Z" /></>, 'AbjadHebrewIcon');
export default AbjadHebrewIcon